/* Filtrous under-header search band v1.4 (2026-08-03) — full-width search bar in
   a strip directly UNDER the header row on EVERY page, BOTH chromes:
     - non-app pages: appended inside nav.fh3 (sections/filtrous-header.liquid)
     - app pages (index/collection/product): appended inside the app's sticky
       .fv3-headrow — an ADDITIONAL field; the app's own single .fv3-search
       keeps its original docking (home intro / sheet head / PDP slot) per
       David 2026-08-03 "don't remove that".
   The section's .fh3-search / .fh3-suggest CSS styles the field on both
   chromes (that style tag renders — hidden — on app pages too), plus the
   band CSS injected below (band spans the page, white ground; v1.4: no
   rule between the logo row and the field — "too many lines" — and the
   field pulled up tighter under the logo row, top pad 10->2px).

   Suggestions come from assets/catalog-index.json (same index the app reads),
   LAZY-fetched on first focus so ordinary page views never pay the ~300KB.
   Groups: Part numbers (SKU substring), Products (title word match), then
   "See all results" -> the app's real /#/s/<q> route on the homepage, which
   also resolves exact SKUs to their PDP by itself (so search works even if
   the index fetch fails). Suggestion rows are real <a> links (middle-click OK).
   No prices in the dropdown - keeps the OSK "Call for Quote" rule out of scope.

   Loader (sections/filtrous-header.liquid) passes the index URL:
     <script src=".../filtrous-header-searchband.js" data-fhsb
             data-index-url="{{ 'catalog-index.json' | asset_url }}" defer></script>
   Additive asset - remove the loader lines to revert. */
(function () {
  'use strict';
  if (window.__fhSearchBand) return;
  window.__fhSearchBand = 1;

  function boot() {
    // Mount target: the fh3 header on non-app pages; the app's sticky
    // .fv3-headrow on app pages (may not exist yet - the app builds its
    // chrome async, so retry via MutationObserver below).
    var isApp = !!document.getElementById('fv3-app');
    var header = isApp ? document.querySelector('#fv3-app .fv3-headrow')
                       : document.querySelector('nav.fh3');
    if (!header) {
      if (isApp && !boot.__watching) {
        boot.__watching = 1;
        var host = document.getElementById('fv3-app') || document.body;
        var obs = new MutationObserver(function () {
          if (document.querySelector('#fv3-app .fv3-headrow')) { obs.disconnect(); boot(); }
        });
        obs.observe(host, { childList: true, subtree: true });
        setTimeout(function () { obs.disconnect(); }, 15000);
      }
      return;
    }
    if (header.querySelector('.fh3-band')) return;

    var loader = document.querySelector('script[data-fhsb]');
    var INDEX_URL = loader ? loader.getAttribute('data-index-url') : null;

    /* ---- band CSS (the field/dropdown styles live in the header section) ---- */
    if (!document.getElementById('fhsb-css')) {
      var st = document.createElement('style');
      st.id = 'fhsb-css';
      st.textContent =
        /* Empire's #site-main is position:relative z-index:500 (theme.css), which
           painted the suggest dropdown BEHIND the page; lift the whole header
           chrome just above it (cart drawer 2147483000 / photoswipe 1500 /
           cookie banner all stay on top). */
        'nav.fh3{z-index:600 !important;}' +
        '.fh3-band{background:#fff;font-family:\'DM Sans\',system-ui,-apple-system,\'Segoe UI\',Roboto,sans-serif;}' +
        '.fh3-band-in{display:flex;padding:2px 22px 10px;}' +
        '.fh3-band .fh3-search{flex:1 1 auto;min-width:0;}' +
        '@media (max-width:820px){.fh3-band-in{padding:2px 14px 8px;}}';
      document.head.appendChild(st);
    }

    /* ---- markup (inner classes = the section's existing search CSS) ---- */
    var band = document.createElement('div');
    band.className = 'fh3-band';
    band.innerHTML =
      '<div class="fh3-band-in">' +
        '<div class="fh3-search" role="search">' +
          '<span class="mag"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="7" cy="7" r="4.5"/><path d="M11 11l3 3"/></svg></span>' +
          '<input type="search" placeholder="Search a part number, membrane, porosity..." autocomplete="off" aria-label="Search parts and categories" />' +
          '<div class="fh3-suggest" role="listbox"></div>' +
        '</div>' +
      '</div>';
    header.appendChild(band);

    var input = band.querySelector('input');
    var box = band.querySelector('.fh3-suggest');

    /* ---- catalog index: lazy, fetched once on first focus ---- */
    var IDX = null, idxPromise = null;
    function normSku(s) { return String(s || '').toUpperCase().replace(/\s+/g, ''); }
    function ensureIndex() {
      if (IDX || !INDEX_URL) return idxPromise || Promise.resolve();
      if (!idxPromise) {
        idxPromise = fetch(INDEX_URL, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { if (d && d.products) IDX = d; })
          .catch(function () { /* no suggestions; submit still works via #/s/ */ });
      }
      return idxPromise;
    }

    /* ---- routing ---- */
    function searchUrl(q) { return '/#/s/' + encodeURIComponent(q); }
    function productUrl(p) { return p.handle ? '/products/' + p.handle : '/#/p/' + encodeURIComponent(p.sku); }
    function go(href) { window.location.href = href; }

    /* ---- suggestions ---- */
    var items = [], activeIdx = -1, timer = null;
    function close() {
      clearTimeout(timer);
      box.classList.remove('on'); box.innerHTML = ''; items = []; activeIdx = -1;
    }
    function addItem(el) { el.setAttribute('data-i', String(items.length)); items.push(el); }
    function row(p) {
      var a = document.createElement('a');
      a.className = 'fh3-sug-item';
      a.href = productUrl(p);
      var part = document.createElement('span');
      part.className = 'fh3-sug-part';
      part.textContent = p.sku;
      var title = document.createElement('span');
      title.className = 'fh3-sug-title';
      title.textContent = String(p.title || '').split(',')[0];
      a.appendChild(part); a.appendChild(title);
      return a;
    }
    function paint() {
      var rows = box.querySelectorAll('[data-i]');
      for (var i = 0; i < rows.length; i++) {
        rows[i].classList.toggle('hl', parseInt(rows[i].getAttribute('data-i'), 10) === activeIdx);
      }
    }
    function suggest(q) {
      q = q.trim();
      if (!q) { close(); return; }
      box.innerHTML = ''; items = []; activeIdx = -1;

      if (IDX) {
        var uq = normSku(q), skuHits = [], titleHits = [], seen = {};
        if (uq.length >= 2) {
          skuHits = IDX.products.filter(function (p) { return normSku(p.sku).indexOf(uq) >= 0; })
            .sort(function (a, b) { return a.sku.length - b.sku.length; }).slice(0, 5);
          skuHits.forEach(function (p) { seen[p.sku] = 1; });
        }
        var words = q.toLowerCase().split(/\s+/).filter(Boolean);
        if (words.length) {
          titleHits = IDX.products.filter(function (p) {
            if (seen[p.sku]) return false;
            var t = String(p.title || '').toLowerCase();
            for (var w = 0; w < words.length; w++) { if (t.indexOf(words[w]) < 0) return false; }
            return true;
          }).slice(0, 5);
        }
        if (skuHits.length) {
          var g1 = document.createElement('div');
          g1.className = 'fh3-sug-group'; g1.textContent = 'Part numbers';
          box.appendChild(g1);
          skuHits.forEach(function (p) { var r = row(p); addItem(r); box.appendChild(r); });
        }
        if (titleHits.length) {
          var g2 = document.createElement('div');
          g2.className = 'fh3-sug-group'; g2.textContent = 'Products';
          box.appendChild(g2);
          titleHits.forEach(function (p) { var r = row(p); addItem(r); box.appendChild(r); });
        }
      }

      var all = document.createElement('div');
      all.className = 'fh3-sug-all';
      all.textContent = 'See all results for “' + q + '”';
      all.addEventListener('mousedown', function (e) { e.preventDefault(); go(searchUrl(q)); });
      addItem(all);
      box.appendChild(all);
      box.classList.add('on');
    }

    function commit() {
      var q = input.value.trim();
      if (!q) { close(); return; }
      if (IDX) {
        var uq = normSku(q);
        for (var i = 0; i < IDX.products.length; i++) {
          if (normSku(IDX.products[i].sku) === uq) { close(); go(productUrl(IDX.products[i])); return; }
        }
      }
      close();
      go(searchUrl(q)); // the app's #/s/ route resolves exact SKUs itself
    }

    /* ---- wiring ---- */
    input.addEventListener('focus', function () { ensureIndex(); });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value;
      timer = setTimeout(function () {
        ensureIndex().then(function () {
          if (input.value === q) suggest(q);
        });
        suggest(q); // instant (index may not be in yet; refreshed by the then())
      }, 150);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(items.length - 1, activeIdx + 1); paint(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(-1, activeIdx - 1); paint(); }
      else if (e.key === 'Enter') {
        if (activeIdx >= 0 && items[activeIdx]) {
          e.preventDefault();
          var el = items[activeIdx];
          if (el.tagName === 'A') go(el.getAttribute('href'));
          else go(searchUrl(input.value.trim()));
        } else { commit(); }
      }
      else if (e.key === 'Escape') { close(); }
    });
    input.addEventListener('blur', function () { setTimeout(close, 140); });
    // mousedown beats the input blur; anchors also keep middle-click behavior
    box.addEventListener('mousedown', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a.fh3-sug-item') : null;
      if (a && e.button === 0) { e.preventDefault(); go(a.getAttribute('href')); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
